<div #containerTemplate class="scroll-adapter__container">
    <div #contentTemplate class="scroll-adapter__content" [class.scroll-adapter__stretch]="stretch"><ng-content></ng-content></div>
</div>
<span #leftArrow class="scroll-adapter__arrow scroll-adapter__arrow--left scroll-adapter__arrow--hidden" (click)="scrollLeft()">
    <span class="theme-left"></span>
</span>
<span #rightArrow class="scroll-adapter__arrow scroll-adapter__arrow--right scroll-adapter__arrow--hidden" (click)="scrollRight()">
    <span class="theme-right"></span>
</span>
